import config from '../common/Config';

// Garante que apenas um refresh acontece por vez.
// Se múltiplas requisições falharem simultaneamente, todas aguardam a mesma Promise.
let pendingRefresh = null;

const refreshToken = () => {
    if (!pendingRefresh) {
        pendingRefresh = fetch(config.apiUrl + '/refresh', { credentials: 'include' })
            .then(async r => {
                if (r.status === 200) return { success: true, data: await r.json() };
                return { success: false, status: r.status };
            })
            .finally(() => { pendingRefresh = null; });
    }
    return pendingRefresh;
};

export default refreshToken;
